import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// CREATE FORM CATEGORY
const submit = (payload) => client.post('forms/categories', payload);
export const useCreateFormCategory = (payload) => useMutation(['createCategory'],() => submit(payload))